import store from './store/store';

import selectable from './vueComponent/ui/selectable';
import uiInput from './vueComponent/ui/ui-input';
import uiSelect from './vueComponent/ui/ui-select';
import loader from './vueComponent/ui/loader';
import popup from './vueComponent/ui/popup';

import registrationComponent from './vueComponent/registrationComponent';
import studioComponent from './vueComponent/studioComponent';
import bookDropDownComponent from './vueComponent/bookDropDownComponent';

import dateComponent from './vueComponent/components/dateComponent';
import instructorComponent from './vueComponent/components/instructorComponent';

export default function () {
    Vue.component('selectable', selectable);
    Vue.component('uiInput', uiInput);
    Vue.component('uiSelect', uiSelect);
    Vue.component('popup', popup);

    Vue.component('dateComponent', dateComponent);
    Vue.component('instructorComponent', instructorComponent);

    //loader not inplemented yet
    Vue.component('loader', loader);

    Vue.component('registrationComponent', registrationComponent);

    Vue.component('studioComponent', studioComponent);

    Vue.component('bookDropDownComponent', bookDropDownComponent);


    new Vue({
        el: "#vue-root",
        store
    });
};



// WEBPACK FOOTER //
// ./assets/js/modules/vue-root.js